module.exports = __webpack_public_path__ + "assets/img/97c838c1acf0cd325897918a1e7d38c2.png";